module.exports = __webpack_public_path__ + "img/CATEGORY ICON-27.cbb27034.png";